import { render } from "./OutlineButtonInertiaLink.vue?vue&type=template&id=209a0586"
import script from "./OutlineButtonInertiaLink.vue?vue&type=script&lang=js"
export * from "./OutlineButtonInertiaLink.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nekenaratafitaharitsimba/Work/HULSIA/PROJECTS/smilemood-v2/smilemood-v2-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"OutlineButtonInertiaLink.vue"]])

export default __exports__